import { useState, useEffect } from 'react';
import isMobileJS from 'ismobilejs';
import { get } from '@/modules/objectUtils';

export default function useIsMobile(
  typeOrMaxWidth: number | string = 'any'
): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const calculateMobileResult = () => {
      let isMobileResult: boolean;
      if (typeof typeOrMaxWidth == 'number') {
        const viewportWidth = window.innerWidth;
        isMobileResult = viewportWidth < typeOrMaxWidth;
      } else {
        isMobileResult = get(isMobileJS(window.navigator), typeOrMaxWidth);
      }

      setIsMobile(isMobileResult);
    };

    calculateMobileResult();
    window.addEventListener('resize', calculateMobileResult);
    return () => window.removeEventListener('resize', calculateMobileResult);
  }, []);

  return isMobile;
}
